function ExRetornoEsocial(retorno) {
    var json = JSON.parse(retorno);
    alert(json.dados);
}